import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

function getTestId(testIdProp) {
  if (testIdProp === undefined) {
    return {
      name: null,
      brand: null,
    };
  }

  return {
    name: `${testIdProp}-name`,
    brand: `${testIdProp}-brand`,
  };
}
/** @type {any} */
const ProductCard = ({
  testId,
  id,
  img,
  brand,
  name,
  packImg,
  isNew,
  isNever,
  tags,
  onClick,
  small,
}) => {
  let isInCustomerNevers = window.customerNevers
    ? window.customerNevers.includes(id)
    : isNever;
  const [markedAsNever, setMarkedAsNever] = useState(isInCustomerNevers);

  useEffect(() => {
    const onProductPeriodicityChanged = (evt) => {
      const { productId, periodicity } = evt.detail;
      if (productId !== id) {
        return;
      }

      setMarkedAsNever(periodicity === 1 ? true : false);

      if (periodicity === 1 && !isInCustomerNevers) {
        window.customerNevers.push(id);
      }

      if (periodicity > 1 && isInCustomerNevers) {
        const removingIdFromNevers = window.customerNevers.filter((n) => {
          return n !== id;
        });
        window.customerNevers = removingIdFromNevers;
      }
    };

    document.addEventListener(
      'product-periodicity-changed',
      onProductPeriodicityChanged
    );

    return () =>
      document.removeEventListener(
        'product-periodicity-changed',
        onProductPeriodicityChanged
      );
  }, []);

  const { name: nameTestId, brand: brandTestId } = getTestId(testId);

  return (
    <div className="product-card-simple" data-testid={`${testId}-container`}>
      <div style={{ position: 'relative' }}>
        <div
          data-id={id}
          style={{ backgroundImage: `url(${img})` }}
          className={`productCardImg${small ? ' small' : ''}`}
          onClick={onClick}
        ></div>
        {packImg ? (
          <img
            src={packImg}
            className="pack-img"
            data-id={id}
            onClick={onClick}
            alt=""
          />
        ) : null}
        {isNew ? (
          <img
            src={`/public/img/edit_delivery/new.svg`}
            className="is_new_icon"
            alt="New icon"
          />
        ) : null}
        {markedAsNever ? (
          <div
            className="hr-overlay marked-never"
            data-id={id}
            onClick={onClick}
          />
        ) : null}
      </div>
      <div className="info">
        <div data-testid={brandTestId} className="brand hr-subtitle-sm">
          {brand}
        </div>
        <div
          data-testid={nameTestId}
          data-id={id}
          className="product-name hr-paragraph-bold"
          onClick={onClick}
        >
          {name}
        </div>
      </div>
      {tags ? (
        <div className="dietary-tags hr-subtitle-sm-bold">
          {tags.join(' \u00B7 ')}
        </div>
      ) : null}
      {markedAsNever ? (
        <div className="marked-never-msg">marked as never</div>
      ) : null}
    </div>
  );
};

ProductCard.propTypes = {
  id: PropTypes.number.isRequired,
  img: PropTypes.string.isRequired,
  brand: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  packImg: PropTypes.string,
};

export default ProductCard;
